import { loadModal } from '../actions/loadModal';
import { handleAjaxError } from '../actions/handleAjaxError';

const ARCHIVE_MODAL_ID = 'growtypeChatArchiveModal';
const RESTORED_SESSION_STORAGE_KEY = 'growtypeChatRestoredSession';

export function showArchiveNotice(message) {
    const existing = document.querySelector('.growtype-chat-archive-notice');
    if (existing) {
        existing.remove();
    }

    const notice = document.createElement('div');
    notice.className = 'growtype-chat-archive-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.textContent = message || 'Moved to archive';
    document.body.appendChild(notice);

    requestAnimationFrame(() => notice.classList.add('is-visible'));
    window.setTimeout(() => {
        notice.classList.remove('is-visible');
        window.setTimeout(() => notice.remove(), 250);
    }, 2000);
}

export function showSessionArchivedState(sessionContainer, message) {
    const card = sessionContainer && sessionContainer.jquery
        ? sessionContainer
        : $(sessionContainer);

    card.find('.growtype-chat-session-archive-state').remove();
    card.addClass('is-archiving');

    const state = $('<span class="growtype-chat-session-archive-state" role="status" aria-live="polite"></span>');
    state.append('<span class="dashicons dashicons-yes-alt" aria-hidden="true"></span>');
    const label = String(message || 'Moved to archive');
    const archiveIndex = label.toLowerCase().lastIndexOf('archive');
    const labelContent = $('<span class="growtype-chat-session-archive-state__label"></span>');

    if (archiveIndex >= 0) {
        labelContent.append(document.createTextNode(label.slice(0, archiveIndex)));
        labelContent.append($('<strong></strong>').text(label.slice(archiveIndex, archiveIndex + 7)));
        labelContent.append(document.createTextNode(label.slice(archiveIndex + 7)));
    } else {
        labelContent.text(label);
    }

    state.attr({
        role: 'button',
        tabindex: '0',
        'aria-label': `${label}. Open archive`,
    });
    state.append(labelContent);
    card.append(state);

    window.requestAnimationFrame(function () {
        state.addClass('is-visible');
    });

    return new Promise(function (resolve) {
        window.setTimeout(function () {
            state.removeClass('is-visible').addClass('is-leaving');
            card.addClass('is-archive-removing');
            window.setTimeout(resolve, 240);
        }, 2000);
    });
}

function openArchiveModal() {
    return loadModal(
        growtype_chat_ajax.get_archive_modal_action,
        function () {
            const modal = document.getElementById(ARCHIVE_MODAL_ID);
            if (modal) {
                window.growtypeModal?.show(modal);
            }
        },
        {
            modalId: ARCHIVE_MODAL_ID,
            replace: true,
            ajaxData: { refresh: Date.now() },
        }
    );
}

function highlightRestoredSession() {
    let restoredSession = null;

    try {
        restoredSession = JSON.parse(window.sessionStorage.getItem(RESTORED_SESSION_STORAGE_KEY) || 'null');
    } catch (error) {
        window.sessionStorage.removeItem(RESTORED_SESSION_STORAGE_KEY);
        return true;
    }

    if (!restoredSession?.token) {
        return true;
    }

    const cards = $('.g-chatsessions-single').filter(function () {
        return $(this).attr('data-token') === restoredSession.token;
    });

    if (cards.length !== 1) {
        return false;
    }

    const card = cards.eq(0);
    const sessionsContainer = card.closest('.g-chatsessions-sessions');
    sessionsContainer.prepend(card);
    sessionsContainer.scrollTop(0);

    card.addClass('is-restored');
    card.find('.growtype-chat-session-restored-state').remove();
    card.append(
        $('<span class="growtype-chat-session-restored-state" role="status" aria-live="polite"></span>')
            .append('<span class="dashicons dashicons-yes-alt" aria-hidden="true"></span>')
            .append($('<strong></strong>').text(restoredSession.message || 'Session restored'))
    );

    window.sessionStorage.removeItem(RESTORED_SESSION_STORAGE_KEY);
    window.setTimeout(function () {
        card.removeClass('is-restored');
        card.find('.growtype-chat-session-restored-state').remove();
    }, 2400);

    return true;
}

export function archiveModal() {
    const storedNotice = window.sessionStorage.getItem('growtypeChatArchiveNotice');
    if (storedNotice) {
        window.sessionStorage.removeItem('growtypeChatArchiveNotice');
        showArchiveNotice(storedNotice);
    }

    if (!highlightRestoredSession()) {
        const handleSessionsRendered = function () {
            if (highlightRestoredSession()) {
                document.removeEventListener('growtypeChatSessionsRendered', handleSessionsRendered);
            }
        };
        document.addEventListener('growtypeChatSessionsRendered', handleSessionsRendered);
    }

    $(document)
        .off('click.growtypeChatArchiveState', '.growtype-chat-session-archive-state')
        .on('click.growtypeChatArchiveState', '.growtype-chat-session-archive-state', function (event) {
            event.preventDefault();
            event.stopPropagation();
            openArchiveModal().catch(function (error) {
                console.error(error);
            });
        })
        .off('keydown.growtypeChatArchiveState', '.growtype-chat-session-archive-state')
        .on('keydown.growtypeChatArchiveState', '.growtype-chat-session-archive-state', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            $(this).trigger('click');
        })
        .off('click.growtypeChatArchiveModal', '[data-growtype-chat-archive-modal-trigger="true"]')
        .on('click.growtypeChatArchiveModal', '[data-growtype-chat-archive-modal-trigger="true"]', function (event) {
            event.preventDefault();
            openArchiveModal().catch(function (error) {
                console.error(error);
            });
        })
        .off('click.growtypeChatArchiveRestore', '.growtype-chat-archive-restore')
        .on('click.growtypeChatArchiveRestore', '.growtype-chat-archive-restore', function (event) {
            event.preventDefault();

            const button = $(this);
            const item = button.closest('[data-archive-session-token]');
            button.prop('disabled', true).addClass('is-loading');

            $.ajax({
                url: growtype_chat_ajax.url,
                type: 'post',
                data: {
                    action: growtype_chat_ajax.session_restore_action,
                    session: { token: item.attr('data-archive-session-token') },
                    nonce: growtype_chat_ajax.nonce,
                },
                success: function (response) {
                    if (!response.success) {
                        button.prop('disabled', false).removeClass('is-loading');
                        handleAjaxError(response);
                        return;
                    }

                    window.sessionStorage.setItem(RESTORED_SESSION_STORAGE_KEY, JSON.stringify({
                        token: response.data.token,
                        message: response.data.message,
                    }));
                    window.location.assign(response.data.redirect_url || window.location.href);
                },
                error: function (response) {
                    button.prop('disabled', false).removeClass('is-loading');
                    handleAjaxError(response);
                },
            });
        });
}
